export default __webpack_public_path__ + "static/media/UA.02506ea0.ico";